import { observer } from "mobx-react-lite";
import { Button } from "@/components/ui/button";
import { FormField, SelectField } from "@/components/common";
import { useTran } from "@/hooks";
import { useAuthStore } from "@/features/auth/hooks";
import { useCarbonTargetsStore } from "../../hooks";

const TargetSettingsFiltersSection = observer(() => {
  const { t } = useTran();
  const store = useCarbonTargetsStore();

  const { user } = useAuthStore();
  const userOrganizations = (user?.organizationUnitId || []).map((org) => ({
    value: org.id,
    label: org.name,
  }));

  const yearOptions = store.yearFilterOptions.map((option) =>
    option.value === "All" ? { ...option, label: t("All") } : option,
  );

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-12 items-end">
      <SelectField
        className="lg:col-span-2"
        label={t("Target Year")}
        value={store.filters.targetYear}
        onValueChange={(value) => store.setFilter("targetYear", value)}
        options={yearOptions}
        placeholder={t("Target Year")}
      />
      <div className="lg:col-span-1">
        <Button
          type="button"
          variant="outline"
          className="w-full"
          onClick={store.clearFilters}
        >
          {t("Clear")}
        </Button>
      </div>
    </div>
  );
});

export default TargetSettingsFiltersSection;
